<section id="impressum" class="page-section">
    <div class="container my-4">
        <h1>Impressum</h1>
        <p>Jan Rasmus Peters, Freiberuflicher Berater und Projektmanager</p>
        <p>
            Am Gosepötken 12
            <br />
            44795 Bochum
        </p>
        <p>
            Umsatzsteuer ID: <i>beantragt</i>
        </p>
        <br />
        <h2>Kontakt</h2>
        <a href="mailto:contact@bitbuckler.com">contact@bitbuckler.com</a>
    </div>
</section>
